// @flow

export type AbsenceReviewSchemaArgs = $Exact<{
  task: Object,
  readonly: boolean,
  reviewPeriodLength: number,
  t: (id: string, obj?: Object) => string,
}>;

export function schemaFnc({ task, readonly, reviewPeriodLength, t }: AbsenceReviewSchemaArgs) {
  let actions = [
    {
      title: "Log New Action",
      const: "LOG_ACTION",
    },
    {
      title: "Maintain Current Status",
      const: "NO_ACTION",
    },
  ];
  if (readonly === true) {
    actions.push({
      title: "Temporarily Defer",
      const: "DEFER",
    });
  }

  return {
    type: "object",
    required: ["action", "notes"],
    dependencies: {
      action: {
        oneOf: [
          {
            properties: {
              action: { const: "NO_ACTION" },
              noActionReason: {
                type: "object",
                title: "Please select your reason for no action needing to be taken:",
                required: ["id"],
                properties: {
                  id: {
                    type: "integer",
                    title: "Please select your reason for no action needing to be taken:",
                    oneOf: task.noActionReasons
                      ? task.noActionReasons.map(a => ({
                          const: a.id,
                          title: a.reason,
                        }))
                      : [],
                  },
                },
              },
            },
            required: ["noActionReason"],
          },
          {
            properties: {
              action: { const: "LOG_ACTION" },
              ...(!readonly
                ? {
                    newLevel: {
                      type: "object",
                      title: "New Level",
                      required: ["id"],
                      properties: {
                        id: {
                          type: "integer",
                          title: t("NEW_ABSENCE_MONITORING_LEVEL"),
                          oneOf: (() => {
                            const { levels, currentLevel } = task;
                            let lev = [{ id: -1, name: "-" }];
                            if (currentLevel) lev = [currentLevel];
                            if (levels.length) lev = levels;
                            //$FlowIgnore
                            return lev.map((a: { id: number, name: string }) => ({
                              const: a.id,
                              title: a.name,
                            }));
                          })(),
                        },
                      },
                    },
                  }
                : {}),
              ...(readonly && task.newLevel
                ? {
                    newLevel: {
                      type: "object",
                      title: "New Level",
                      required: ["id"],
                      properties: {
                        id: {
                          type: "integer",
                          title: t("NEW_ABSENCE_MONITORING_LEVEL"),
                          oneOf: (() => {
                            if (readonly && task.newLevel) {
                              return [
                                {
                                  const: task.newLevel.id,
                                  title: task.newLevel.name,
                                },
                              ];
                            }

                            return [{ const: -1, title: "-" }];
                          })(),
                        },
                      },
                    },
                  }
                : {}),
              ...(readonly && !task.newLevel && task.currentLevel
                ? {
                    currentLevel: {
                      type: "object",
                      title: "New Level",
                      required: ["id"],
                      properties: {
                        id: {
                          type: "integer",
                          title: t("NEW_ABSENCE_MONITORING_LEVEL"),
                          oneOf: (() => {
                            if (readonly && task.currentLevel) {
                              return [
                                {
                                  const: task.currentLevel.id,
                                  title: task.currentLevel.name,
                                },
                              ];
                            }

                            return [{ const: -1, title: "" }];
                          })(),
                        },
                      },
                    },
                  }
                : {}),
              meetingDate: {
                type: "string",
                title: t("EFFECTIVE_FROM_DATE"),
                format: "date",
              },
              additionalSupportActionsTaken: {
                type: "array",
                title: t("STEP_ADDITIONAL_SUPPORT_ACTIONS"),
                items: {
                  type: "object",
                  required: ["id"],
                  properties: {
                    id: {
                      type: "integer",
                      title: "Absence Monitoring Additional Support Action",
                      oneOf: task.additionalSupportActions
                        ? task.additionalSupportActions.map(a => ({
                            const: a.id,
                            title: a.action,
                          }))
                        : [{ const: -1, title: "" }],
                    },
                  },
                },
              },
              nextReviewDate: {
                type: "string",
                title: t("SET_REVIEW_DATE"),
                format: "date",
              },
              completedTasks: {
                type: "array",
                title:
                  "The following tasks will need to be completed as a result of your choices above. Please indicate which tasks you have already completed. The remaining tasks will appear in your Task Queue.",
                items: {
                  type: "object",
                  required: ["id"],
                  properties: {
                    id: {
                      type: "integer",
                      title: "Absence Monitoring Process Task",
                      oneOf: task.tasks
                        ? [
                            ...task.tasks.map(a => ({
                              const: a.id,
                              title: a.name,
                            })),
                          ]
                        : [{ const: -1, title: "-" }],
                    },
                  },
                },
              },
            },
            required: ["newLevel", "meetingDate"],
          },
        ],
      },
    },
    properties: {
      action: {
        type: "string",
        title: t("DECISION_MADE"),
        oneOf: actions,
      },
      notes: {
        type: "string",
        title: t("ADDITIONAL_NOTES"),
      },
    },
    urn: "urn:jsonschema:eu:firstcare:api:v1:dto:tools:tasks:AbsenceMonitoringReviewTaskDTO",
  };
}
